import { render, staticRenderFns } from "./ChecklistPage.vue?vue&type=template&id=33881d12&scoped=true"
import script from "./ChecklistPage.vue?vue&type=script&lang=js"
export * from "./ChecklistPage.vue?vue&type=script&lang=js"
import style0 from "./ChecklistPage.vue?vue&type=style&index=0&id=33881d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33881d12",
  null
  
)

export default component.exports